var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperienceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#0087D0",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#0087D0",
    opacity: 0.1,
    cx: 6.5,
    cy: 6.364,
    rx: 6.5,
    ry: 6.364
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0087D0",
    opacity: 0.1,
    d: "M2.98 11.718L1.858 20 6.5 17.273 11.143 20l-1.124-8.29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 6.364,
    rx: 6.5,
    ry: 6.364
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98 11.718L1.858 20 6.5 17.273 11.143 20l-1.124-8.29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceIcon);
export default __webpack_public_path__ + "static/media/experienceIcon.66417ea9.svg";
export { ForwardRef as ReactComponent };